module.exports = "/images/Argentina.png?db281f880d29780fef4545c9a3073812";